import React, { cloneElement, useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

export const Portal = ({
  children,
  className = 'root-portal',
  el = 'div',
  zIndex = 99999,
}: {
  children: any
  className?: string
  el?: string
  zIndex?: number
}) => {
  const [container] = useState(() => {
    // This will be executed only on the initial render
    // https://reactjs.org/docs/hooks-reference.html#lazy-initial-state
    if (document) return document.createElement(el)
    return undefined
  })

  useEffect(() => {
    if (container && document) {
      container.classList.add(className)
      document.body.appendChild(container)
    }
    return () => {
      if (container && document) {
        document.body.removeChild(container)
      }
    }
  }, [className, container])

  if (container)
    return createPortal(
      cloneElement(children, {
        zIndex,
      }),
      container
    )

  return <></>
}
